import { useLayoutEffect, useState, type RefObject } from "react";

export const useAgGridChromeHeights = (
  gridContainerRef: RefObject<HTMLDivElement | null>,
  isLoading: boolean,
) => {
  const [gridChromeHeights, setGridChromeHeights] = useState({ header: 0, footer: 0 });

  useLayoutEffect(() => {
    if (!isLoading) {
      return;
    }

    const container = gridContainerRef.current;
    if (!container) {
      return;
    }

    const measure = () => {
      const header =
        container.querySelector<HTMLElement>(".ag-header") ??
        container.querySelector<HTMLElement>(".ag-header-root");
      const footer = container.querySelector<HTMLElement>(".ag-paging-panel");
      setGridChromeHeights({
        header: header?.offsetHeight ?? 0,
        footer: footer?.offsetHeight ?? 0,
      });
    };

    measure();

    const resizeObserver = new ResizeObserver(() => {
      measure();
    });
    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
    };
  }, [gridContainerRef, isLoading]);

  return gridChromeHeights;
};
